import { CURRENT_CART_FOOTER } from "../../../../../Data/FormLayout";

const CurrentCartTableFooter = () => {
  return (
    <tfoot>
      {CURRENT_CART_FOOTER.map((data, index) => (
        <tr key={index}>
          <td>{data.footerTittle}</td>
          <td colSpan={2}>${data.price} </td>
        </tr>
      ))}
    </tfoot>
  );
};

export default CurrentCartTableFooter;
